import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { OpenInViewIcon } from "shared/theme/icons/OpenInViewIcon";

type LinkProps = {
  link: string;
  title: string;
};

const iCoreLink = process.env.REACT_APP_ICORE_LINK;

const Link: React.FC<LinkProps> = ({ link, title }) => (
  <Box display="flex" columnGap="4px" alignItems="center">
    <a
      href={`${iCoreLink}${link}`}
      style={{ textDecoration: "none" }}
      target="_blank"
      rel="noreferrer"
    >
      <Typography variant="bodyMRegular" color={COLOR_PRIMARY_MAIN}>
        {title}
      </Typography>
    </a>

    <OpenInViewIcon />
  </Box>
);

export default Link;
